import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
import "./styles.css";
import {Collapse, Checkbox, message, Divider, Button, Tooltip, Switch} from "antd";
import {consultantService} from "../../services/consultant.service";
import {
  BulbOutlined,
  CheckSquareOutlined,
  ExceptionOutlined,
  FilePdfOutlined,
  InfoCircleOutlined,
  RedoOutlined,
  SelectOutlined,
  SendOutlined
} from "@ant-design/icons";
import moment from "moment";

export default function UserAnvView(props) {
  const {t} = useTranslation();
  const [form, setForm] = useState([]);
  const [forceRender, setForceRender] = useState(true);
  const [invoices, setInvoices] = useState(null);
  const [toDoList, setToDoList] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [actionRequiredInvoices, setActionRequiredInvoices] = useState([]);
  const [activeColum, setActiveColumn] = useState(["3"]);
  const [suggestComment, setSuggestComment] = useState(false);

  const renderQuestionComp = (array, group) => {
    const result = [];
    const breakpoint = /"|\[|\]|\{|\}/;

    if (!array || array.length == 0) return;

    array[group].forEach(el => {
      if (el.loop) {
        //
        const loopAnswer = [];
        el.answer.forEach(item => {
          const answerSpan = [];
          let answerString = `${JSON.stringify(item) || item}`.split(breakpoint).join(" ");
          answerString = answerString.split("|/|");
          answerString.forEach(ell => {
            const temp = <span>{ell}</span>;
            answerSpan.push(temp);
            answerSpan.push(<br />);
          });
          const answerDiv = <div className="answer_span">{answerSpan}</div>;
          loopAnswer.push(answerDiv);
        });
        result.push(
          <div key={group + "-" + el.id} className="question_div">
            <span style={{width: "50%"}}>
              {el.id}: {el.text}
            </span>
            {loopAnswer.reverse()}
          </div>
        );
      } else {
        const answerSpan = [];
        let answerString = `${JSON.stringify(el.answer) || el.answer}`.split(breakpoint).join(" ");
        answerString = answerString.split("|/|");
        answerString.forEach(el => {
          const temp = <span>{el}</span>;
          answerSpan.push(temp);
          answerSpan.push(<br />);
        });
        const answerDiv = <div className="answer_span">{answerSpan}</div>;

        result.push(
          <div key={group + "-" + el.id} className="question_div">
            <span style={{width: "50%"}}>
              {el.id}: {el.text}
            </span>
            {answerDiv}
          </div>
        );
      }
    });
    return result;
  };

  const getInvoices = async () => {
    try {
      if (!props.data?.form_id) return;
      const result = await new consultantService().getInvoices(props.data.form_id);

      //console.log(result);
      setInvoices(
        result.map((el, idx) => ({
          key: idx,
          label: el.label,
          value: el.key
        }))
      );
    } catch (err) {
      //console.log(err);
    }
  };

  const getActionRequiredInvoices = async () => {
    try {
      if (!props.data?.form_id) return;
      const result = await new consultantService().getActionRequiredInvoices(props.data.form_id);

      //console.log(result);
      setActionRequiredInvoices(result.invoices.map((el, idx) => ({key: idx, ...JSON.parse(JSON.stringify(el))})));
    } catch (err) {
      //console.log(err);
    }
  };

  const displayInvoices = invoices?.filter(el => {
    return !actionRequiredInvoices?.map(el => el.type).includes(el.value);
  });

  const isActionDisabled = el => {
    return !el.new_comment || ["lost", "approved", "created"].includes(el.status) || el.new_comment.length < 6;
  };

  const isActionCommentDisabled = el => {
    return !el.new_comment || ["lost", "approved", "rejected"].includes(el.status) || el.new_comment.length < 6;
  };

  const approveInvoice = async data => {
    try {
      const result = await new consultantService().confirmInvoices({
        id: data.invoiceId,
        consultantCorrectedExpenseAmount: data.consultantCorrectedExpenseAmount || null
      });
      if (result.success) {
        messageApi.open({
          type: "success",
          content: "Belege genehmigt",
          style: {
            fontSize: "large",
            color: "rgba(0, 190, 170, 1)"
          }
        });
        setActionRequiredInvoices([]);
        setTimeout(() => {
          getActionRequiredInvoices();
        }, 200);
      } else {
        messageApi.open({
          type: "danger",
          content: "Ein Fehler ist aufgetreten",
          style: {
            fontSize: "large",
            color: "rgba(255, 0, 0, 1)"
          }
        });
      }
    } catch (err) {
      //console.log(err);
    }
  };

  const sendConsultantComment = async data => {
    //console.log(data);
    const result = await new consultantService().sendConsultantComment(data);

    if (result.success) {
      messageApi.open({
        type: "success",
        content: result.data.slice(0, 20) + "...",
        style: {
          fontSize: "large",
          color: "rgba(0, 190, 170, 1)"
        }
      });
      setActionRequiredInvoices([]);
      setTimeout(() => {
        getActionRequiredInvoices();
      }, 200);
    } else {
      messageApi.open({
        type: "danger",
        content: "Ein Fehler ist aufgetreten",
        style: {
          fontSize: "large",
          color: "rgba(255, 0, 0, 1)"
        }
      });
    }
  };

  const reRequestInvoice = data => {
    try {
      new consultantService().reRequestInvoice(data);
      setActionRequiredInvoices([]);
      setTimeout(() => {
        getActionRequiredInvoices();
      }, 200);
      messageApi.open({
        type: "success",
        content: "Belege wieder beantragt",
        style: {
          fontSize: "large",
          color: "rgba(0, 190, 170, 1)"
        }
      });
    } catch (err) {
      //console.log(err);
    }
  };

  const handleCorrectedExpenseInput = (val, el) => {
    el.consultantCorrectedExpenseAmount = val.target.value;
  };

  const renderRequiredColumns = actionRequiredInvoices
    .sort((a, b) => a.key - b.key)
    .map((el, ind) => {
      const temp = el.createdAt.split("T");
      const displayDate = temp[0].split("-").reverse().join(".") + ", " + temp[1].split(".")[0].slice(0, temp[1].split(".")[0].length - 3) + " Uhr";
      return (
        <div
          style={{
            margin: "20px",
            backgroundColor: "rgba(210,210,210,0.3)",
            borderRadius: "15px",
            border: "1px solid rgba(210,210,210,1)",
            padding: "45px"
          }}
          key={"actionRequired-" + ind}
        >
          <div style={{display: "flex", verticalAlign: "middle", justifyContent: "space-between", width: "100%"}}>
            <div style={{width: "20%", fontSize: "15px"}}>
              <h1 style={{fontWeight: "bold"}}>Überblick</h1>
              <p>
                <span style={{color: "grey"}}>Position:</span> <br />
                <span style={{fontWeight: "bold"}}>{el.invoiceType}</span>
              </p>
              <p>
                <span style={{color: "grey"}}>Betrag:</span> <br />
                <span style={{fontWeight: "bold"}}>{el.amount}</span>
              </p>
              <p>
                <span style={{color: "grey"}}>Beantragt am:</span> <br />
                <span style={{fontWeight: "bold"}}>{displayDate}</span>
              </p>
              <p>
                <span style={{color: "grey"}}>Status:</span> <br />
                <span style={{fontWeight: "bold"}}>{`${t("consultantPanel.invoiceFileStatus." + el.status)}`.toUpperCase()}</span>
              </p>
              <p>
                <span style={{color: "grey"}}>ID:</span> <br />
                <span style={{fontWeight: "bold"}}>{el.invoiceId}</span>
              </p>
              <p>
                <span style={{color: "grey"}}>Korrigierter Betrag:</span> <br />
                <input
                  onChange={e => handleCorrectedExpenseInput(e, el)}
                  type="number"
                  style={{
                    padding: "15px",
                    borderRadius: "20px",
                    cursor: el.status != "uploaded" && el.status != "created" ? "not-allowed" : "auto",
                    backgroundColor: "rgba(0, 190, 170, 0.3)",
                    border: "solid 1px rgba(0, 190, 170, 1)",
                    color: "black"
                  }}
                  // SHORT FIX -- REMOVE LATER !!!!!!!
                  disabled={el.status != "uploaded" && el.status != "created"}
                  placeholder={el.ccea || "0.00€"}
                ></input>
              </p>
            </div>
            <div style={{width: "50%"}}>
              <h1 style={{fontWeight: "bold"}}>Kommentarverlauf</h1>
              <div style={{height: "70%", backgroundColor: "white", padding: "15px", borderRadius: "15px", border: "1px solid rgba(210,210,210,1)"}}>
                {el.comments.map((ell, indxx) => (
                  <div style={{width: "100%"}} key={"comment-" + el.invoiceId + "-" + indxx}>
                    <div
                      style={{
                        maxHeight: "120px",
                        overflow: "scroll",
                        marginTop: "10px",
                        marginBottom: "10px",
                        borderRadius: "15px",
                        padding: "10px",
                        width: "70%",
                        marginLeft: ell.type == "user" ? "30%" : "10px",
                        backgroundColor: ell.type == "user" ? "rgba(100,100,100,1)" : "rgba(0, 190, 170, 1)",
                        color: "rgba(255,255,255,0.8)"
                      }}
                    >
                      <p
                        style={{
                          marginBottom: "0px"
                        }}
                      >
                        {ell.comment}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          fontSize: "10px"
                        }}
                      >
                        {ell.createdAt.split("T")[0].split("-").reverse().join(".")}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{display: "flex", flexDirection: "row", flexWrap: "nowrap"}}>
                <textarea
                  style={{
                    marginTop: "20px",
                    padding: "15px",
                    width: "90%",
                    border: isActionDisabled(el) ? "solid 1px grey" : "solid 1px black",
                    backgroundColor: "white",
                    borderRadius: "15px"
                  }}
                  cols={20}
                  rows={1}
                  placeholder="Neuer Kommentar"
                  value={el.new_comment}
                  onChange={e => {
                    const temp = {...el, new_comment: e.target?.value};
                    setActionRequiredInvoices(old => [...old.filter(ell => ell.key != el.key), temp]);
                  }}
                ></textarea>
                <Button
                  style={{
                    marginTop: "20px",
                    marginLeft: "10px",
                    padding: "15px",
                    height: "100%",
                    width: "10%",
                    fontSize: "20px",
                    borderRadius: "15px",
                    color: "white",
                    backgroundColor: "rgba(0, 190, 170, 1)"
                  }}
                  disabled={isActionCommentDisabled(el)}
                  onClick={() => sendConsultantComment({invoiceId: el.invoiceId, commentContent: el.new_comment})}
                >
                  <SendOutlined />
                </Button>
                <Button
                  style={{
                    marginTop: "20px",
                    marginLeft: "10px",
                    padding: "15px",
                    height: "100%",
                    width: "10%",
                    fontSize: "20px",
                    borderRadius: "15px",
                    color: "white",
                    backgroundColor: "rgba(0, 190, 170, 1)"
                  }}
                  disabled={isActionDisabled(el)}
                  onClick={() => reRequestInvoice({invoiceId: el.invoiceId, comment: el.new_comment})}
                >
                  <RedoOutlined />
                </Button>
              </div>
            </div>
            <div style={{width: "20%"}}>
              <h1 style={{fontWeight: "bold", display: "flex", justifyContent: "space-between"}}>
                <span>Beleg</span>
                <Tooltip
                  title={
                    "Bild und Dokument-Links sind aus Sicherheitsgründen nur für 3 Minuten verfügbar, bitte 'ANV Prüfen'-Fenster bei Lade-Problemen schließen und wieder öffnen"
                  }
                >
                  <InfoCircleOutlined style={{fontSize: "20px", marginLeft: "auto"}} />
                </Tooltip>
              </h1>
              <div
                style={{
                  height: "70%",
                  backgroundColor: "white",
                  borderRadius: "15px",
                  textAlign: "center",
                  marginBottom: "25px",
                  border: "1px solid rgba(210,210,210,1)"
                }}
              >
                {!el.file && (
                  <div
                    style={{
                      padding: "30px",
                      textAlign: "center",
                      color: "grey",
                      fontWeight: "bold"
                    }}
                  >
                    <ExceptionOutlined
                      style={{
                        marginTop: "25%",
                        fontSize: "60px"
                      }}
                    />
                    <p> Kein Beleg hochgeladen</p>
                  </div>
                )}
                {el.file && !el.file?.includes(".pdf") && (
                  <img
                    onClick={() => (el.file ? window.open(el.file, "_blank") : null)}
                    style={{width: "100%", padding: "15px", borderRadius: "15px", cursor: "pointer"}}
                    src={el.file}
                    alt="Fehler beim Laden"
                  />
                )}
                {el.file?.includes(".pdf") && (
                  <a onClick={() => (el.file ? window.open(el.file, "_blank") : null)} style={{fontSize: "90px", cursor: "pointer"}}>
                    <FilePdfOutlined
                      style={{
                        marginTop: "35%"
                      }}
                    />
                  </a>
                )}
              </div>
              <Button
                style={{
                  backgroundColor: "rgba(0, 190, 170, 1)",
                  color: "white",
                  padding: "15px",
                  borderRadius: "15px",
                  width: "100%",
                  height: "60px",
                  fontSize: "15px"
                }}
                onClick={() => approveInvoice(el)}
                // SHORT TERM -- FIX LATER !!!!!!!
                disabled={["lost", "approved"].includes(el.status)}
              >
                Beleg genehmigen
              </Button>
            </div>
          </div>
        </div>
      );
    });

  useEffect(() => {
    setForm(props.data?.questions);
    if (!props.isAdmin) {
      setInvoices([]);
      setActiveColumn(["3"]);
      setToDoList([]);
      setActionRequiredInvoices([]);
      getActionRequiredInvoices();
      getInvoices();
    }
  }, [props.data]);

  useEffect(() => {
    setForceRender(!forceRender);
  }, [form]);

  const onInvoiceCheck = selectedKey => {
    if (!invoices) return;
    const temp = invoices.find(el => el.value == selectedKey);
    const inTodo = toDoList.map(el => el.value).includes(temp.value);

    let tempToDo = [...toDoList];
    if (!inTodo) {
      temp.comment = "";
      tempToDo.push(temp);
    } else {
      tempToDo = tempToDo.filter(el => el.value != temp.value);
    }
    setToDoList(tempToDo);
  };

  const sendRequestInvoice = async () => {
    const data = toDoList.map(el => ({type: el.value, comment: el.comment}));
    await new consultantService().requestInvoice({
      formId: props.data.form_id,
      data: data
    });
    props.flag(() => false);
    messageApi.open({
      type: "success",
      content: "Belege beantragt",
      style: {
        fontSize: "large",
        color: "rgba(0, 190, 170, 1)"
      }
    });
  };

  const renderToDoTable = () => {
    const suggestionColors = ["rgba(200,100,0,0.1)", "rgba(100,200,0,0.1)", "rgba(0,100,200,0.1)", "rgba(200,100,200,0.1)", "rgba(200,100,200,0.1)", "rgba(200,100,200,0.1)", "rgba(200,100,200,0.1)", "rgba(200,100,200,0.1)", "rgba(200,100,200,0.1)"];
    return toDoList
      ?.sort((a, b) => a.key - b.key)
      .map((el, idx) => {
        const suggestions = [
          `Lieber User,

Bitte lade deine Rechnung bis spätestens **DATE** hoch.
Bitte beachte: Sollte weder der Rechnungsbetrag, noch andere Angaben der Rechnung, mit deinem geltend gemachten Betrag übereinstimmen, können wir diesen Betrag bei deiner Arbeitnehmerveranlagung nicht steuermindernd geltend machen.
Wir reichen deine Erklärung dann ohne diesen Betrag ein. Dadurch ändert sich deine Steuerbelastung und somit der Betrag deiner Rückerstattung.`,
          "Bitte belegen",
          `Der Wert ${el.label.split(":")[1]} für die Ausgabe scheint uns zu hoch.`,
          "Eine Rechnung wäre notwendig",
	        "Der Beleg, den du hochgeladen hast, entspricht nicht dem richtigen Jahr. Die Rechnung ist aus dem Jahr **YEAR**, wurde aber in der Arbeitnehmerveranlagung des Jahres **YEAR** geltend gemacht. Bitte lade die richtige Rechnung hoch.",
	        "Aus dem Beleg, den du hochgeladen hast, geht nicht derselbe Betrag hervor, der in deiner Steuererklärung von dir eingetragen wurde. Bitte prüfen den Betrag nochmals und gib entweder den neuen richtigen Betrag ein oder lade die richtige Rechnung hoch.",
	        "Der von dir hochgeladene Beleg entspricht nicht der Ausgabenkategorie, die du geltend machen wolltest. Bsp: **REASON**. Bitte prüfe das nochmals und lade die richtige Rechnung hoch.",
	        "Deine Rechnung lautet nicht auf deinen Namen. Kannst du bitte bestätigen, dass diese Ausgaben im Nachhinein von dir an die Person ersetzt wurden.",
	        "Du hast nur einen Zahlungsbeleg, aber keine Rechnung hochgeladen. Für uns geht aus diesem Beleg nicht hervor z.B. **REASON**. Bitte lade noch einen Nachweis dazu hoch.",
        ];
        return (
          <li
            key={"toDoTable-" + idx}
            style={{
              width: "90%",
              display: "flex",
              flexDirection: "column",
              flexWrap: "nowrap",
              justifyContent: "space-between",
              padding: "10px",
              margin: "10px"
            }}
          >
            {/* <span style={{paddingTop: "25px"}}>{el.key}</span> */}
            <Divider style={{marginBottom: "-10px"}} orientation="left">
              {el.label.split(": ")[0]}
            </Divider>
            <textarea
              style={{marginTop: "20px", marginLeft: "10px", padding: "15px", width: "100%", border: "solid 1px black", borderRadius: "15px"}}
              cols={20}
              rows={1}
              placeholder="Kommentar"
              value={el.comment}
              onChange={e => {
                const temp = {...el, comment: e.target?.value};
                setToDoList(old => [...old.filter(ell => ell.key != el.key), temp]);
              }}
            ></textarea>
            <div
              style={{
                display: suggestComment ? "inherit" : "none"
              }}
              className="suggestionbox"
            >
              {suggestions.map((sug, idx) => (
                <p
                  onClick={() => {
                    const temp = {...el, comment: sug};
                    setToDoList(old => [...old.filter(ell => ell.key != el.key), temp]);
                  }}
                  key={sug + "-" + idx}
                  style={{
                    backgroundColor: suggestionColors[idx],
                    color: suggestionColors[idx].replace("0.1", "1"),
                    cursor: "pointer"
                  }}
                  className="comment_suggestions"
                >
                  <span>
                    <BulbOutlined /> {sug}
                  </span>
                </p>
              ))}
            </div>
          </li>
        );
      });
  };

  const renderCheckboxes = () => {
    if (!displayInvoices || displayInvoices?.length == 0) return;
    const result = [];
    for (const option of displayInvoices) {
      const isChecked = toDoList.map(el => el.value).includes(option.value);
      const temp = (
        <div className="taxefy_checkbox" onClick={() => onInvoiceCheck(option.value)}>
          <div
            style={{
              color: isChecked ? "rgba(0, 190, 170, 1)" : "grey",
              fontSize: "25px"
            }}
          >
            <CheckSquareOutlined />
          </div>
          <div className="taxefy_checkbox_item">{option.label.split(":")[0]}</div>
          <div className="taxefy_checkbox_item">{option.label.split(":")[1]}</div>
        </div>
      );
      result.push(temp);
    }
    return result;
  };

  return (
    <>
      {contextHolder}
      <div hidden={props.isAdmin}>
        <span>Kommentar-Vorschläge</span>
        <Switch style={{marginLeft: "10px"}} onChange={() => setSuggestComment(!suggestComment)} size="small" />
      </div>
      <Collapse activeKey={activeColum} defaultActiveKey={activeColum} onChange={el => setActiveColumn(el)}>
        <Collapse.Panel key={1} header="Nutzer-Antworten">
          <div id="user_anv_view_main_box">
            <div style={{marginTop: "10px"}} className="question_group">
              <h1>Allgemein</h1>
              {renderQuestionComp(form, 1)}
            </div>
            <div className="question_group">
              <h1>Familie</h1>
              {renderQuestionComp(form, 2)}
            </div>
            <div className="question_group">
              <h1>Arbeit</h1>
              {renderQuestionComp(form, 3)}
            </div>
            <div className="question_group">
              <h1>Gesundheit</h1>
              {renderQuestionComp(form, 4)}
            </div>
            <div className="question_group">
              <h1>Kinder</h1>
              {renderQuestionComp(form, 5)}
            </div>
          </div>
        </Collapse.Panel>
        {!props.isAdmin && (
          <>
            <Collapse.Panel
              style={{
                userSelect: "none"
              }}
              key={2}
              header="Formular-Belege beantragen"
            >
              <div
                style={{
                  width: "100%",
                  height: "55vh",
                  overflow: "scroll",
                  padding: "20px",
                  display: "flex",
                  flexWrap: "nowrap",
                  justifyContent: "space-around"
                }}
              >
                <div style={{width: "40%"}}>{renderCheckboxes()}</div>

                <div
                  style={{width: "50%", borderRadius: "15px", boxShadow: toDoList.length == 0 ? "none" : "0px 0px 20px 10px rgba(210,210,210, 0.4)"}}
                >
                  <div hidden={toDoList.length == 0}>
                    <h1 style={{margin: "10px", padding: "10px", fontWeight: "bold"}}>Belege beantragen</h1>
                    <div style={{height: "40vh", overflow: "scroll"}}> {renderToDoTable()}</div>
                  </div>
                </div>
              </div>
              <Button
                onClick={() => sendRequestInvoice()}
                disabled={toDoList.length == 0}
                style={{
                  marginLeft: "75%",
                  backgroundColor: "rgba(0, 190, 170, 1)",
                  color: "white",
                  padding: "15px",
                  borderRadius: "15px",
                  width: "20%",
                  height: "60px",
                  fontSize: "15px"
                }}
              >
                Beleg{toDoList.length > 1 ? "e" : ""} beantragen
              </Button>
            </Collapse.Panel>
            <Collapse.Panel
              style={{
                userSelect: "none"
              }}
              key={3}
              header="Formular-Belege"
            >
              {renderRequiredColumns}
            </Collapse.Panel>
          </>
        )}
      </Collapse>
    </>
  );
}
